import { atom } from 'recoil'

import { DeleteClaimApprovalModalProps } from './types'

const deleteClaimApprovalModal: DeleteClaimApprovalModalProps = {
  open: false,
  backofficeUserId: undefined,
  fullname: undefined,
  onSuccess: undefined,
}

const deleteClaimApprovalModalAtom = atom({
  key: 'deleteClaimApprovalModalAtom',
  default: deleteClaimApprovalModal,
})

export default deleteClaimApprovalModalAtom
